import React from "react";
import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";

export default function MobileApp() {
  return (
    <>
      <Navbar transparent />
      <section class="text-gray-600 body-font" id="mobile">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col text-center w-full mb-20">
      <h2 class="text-xs text-indigo-500 tracking-widest font-medium title-font mb-1">Hire Mobile App Developers To Deliver Stunning Apps For
iPhones & iPads!
</h2>
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-500">Hire Mobile App Developers To Deliver Stunning Apps For
iPhones & iPads!</h1>
      <p class="lg:w-2/3 mx-auto leading-relaxed text-base">Get help from Dave's  to hire seasoned Mobile App Developers, programmers, and techies and utilize their advanced skills to create the apps of the future. Our teams of carefully chosen iOS developers are proficient in business applications, communications, and working in cross-functional teams.</p>
    </div>
    <div class="flex flex-col text-center w-full mb-20">
     
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Why Choose Dave's  For Mobile App Developers?
</h1>
     
    </div>
    <div class="flex flex-wrap">
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">24x7 Unwavering Support</h2>
        <p class="leading-relaxed text-base mb-4">Fretting about loading time issues? Don't worry! Our Mobile App Developers developers will be available to resolve any errors and problems for you instantaneously.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Flexible Hiring</h2>
        <p class="leading-relaxed text-base mb-4">Need Mobile App Developers for a single project? On Dave's Brother Technology, you can hire a team of developers that will be committed to your project until its completion. What's more? You can vary your team size according to your needs.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Save Time & Money</h2>
        <p class="leading-relaxed text-base mb-4">You don't need to break your bank to hire Mobile App Developers anymore. Dave's  smoothens the hiring process for you - It's economical and best suited for startups/SMEs.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Customer Is King!</h2>
        <p class="leading-relaxed text-base mb-4">You are our priority. We are resilient about the service we provide and make sure you get to work with the best Mobile App Developers</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
    </div>
    
  </div>
</section>

<section class="text-gray-600 body-font">
    <div class="flex flex-col text-center w-full mb-20">
     
     <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Benefits Of Choosing Mobile App Developers For Your Company

</h1>
    
   </div>
  <div class="container px-5 py-24 mx-auto flex flex-wrap">
    <div class="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden">
      <img alt="feature" class="object-cover object-center mt-20-px h-300 w-300" src="https://engineerbabu.com/img/new/flutter/flutter_benefit.png"/>
    </div>
    <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Increased Brand Awareness</h2>
          <p class="leading-relaxed text-base text-gray-900">An average phone user spends around 3 hours every day on various apps. Apps increase your brand's visibility. A mobile app can inform customers about new products, offers, events, new features, and much more.</p>
          
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp; Increased Sales & Profits</h2>
          <p class="leading-relaxed text-base text-gray-900">Increased visibility leads to more leads, more leads lead to more sales, and more sales lead to more profits. It is a process that begins with the visibility that a mobile app can get you.</p>
         
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Gain Customer Insight</h2>
          <p class="leading-relaxed text-base text-gray-900">The behavior of customers on your app is a great way to gain insight into what they want. You can then devise a new product or service that caters to this demand, or make changes to serve your consumers better.</p>
          
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Gain Competitive Advantage</h2>
          <p class="leading-relaxed text-base text-gray-900">When you hire mobile app developers to create an app for your business, you gain an edge over your competitors. Customers today are more likely to shop from a mobile app than from a website.</p>
        </div>

        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Effective Marketing</h2>
          <p class="leading-relaxed text-base text-gray-900">While there are various ways to market your product, push notifications from an app have the greatest impact. Customers with the app are more likely to open the app and make a purchase when they see activity.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<Footer />
    </>
  );
}